import axios from 'axios'
import Cookies from 'js-cookie'

export default {
    computed: {
        exportTask: function() {
            return this.$store.state.export
        }
    },
    mounted: function() {
        this.tryRestoreTask()
    },
    methods: {
        // 发起导出
        doExport: function(options){
            var self = this;
            var url = options.url;
            var params = options.params
            var statusUrl = options.statusUrl

            if (self.exportTask.isExporting) {
                self.$message.warning('有导出任务进行中');
                return;
            }

            // 先确保 websocket 连接正常
            self.ensureConnected();

            self.$store.dispatch('export/resetExport');
            self.$store.dispatch('export/setExport', {
                isExporting: true,
                show: true,
                status: 'processing',
                timeText: '准备中...',
                startTime: Date.now(),
                statusUrl: statusUrl
            })

            var token = Cookies.get('view_userToken')

            axios.post(url, params, {
                headers: { Authorization: 'Bearer ' + token }
            }).then(function(res) {
                if (res.data.code != 200 && res.data.code != '200') {
                    throw new Error(res.data.msg || '导出失败')
                }

                var taskId = res.data.data.task_id
                self.$store.dispatch('export/setExport', { taskId: taskId })
                self.subscribeProgress(taskId);
            }).catch(function(err){
                self.$store.dispatch('export/setExport', {
                    status: 'failed',
                    errorMsg: err.message || '导出失败',
                    isExporting: false
                })
            })
        },

        // 确保 Websocket 已连接，断开就重连
        ensureConnected: function() {
            var pusher = this.$echo.connector.pusher;
            var state = pusher.connection.state;

            if(state !== 'connected') {
                console.log('Websocket 未连接, 状态：' + state + ', 正在重连...');
                pusher.connect();
            }

            // 更新auth token (可能过期)
            this.$echo.connector.options.auth.headers.Authorization = 'Bearer ' + Cookies.get('view_userToken')
        },

        // 恢复任务
        tryRestoreTask: function() {
            var self = this;
            self.$store.dispatch('export/restoreExport').then(function(saved) {
                if (!saved || saved.status !== 'processing' || !saved.taskId) return;

                const token = Cookies.get("view_userToken");
                var statusUrl = saved.statusUrl || self.$root.commonPreUrl + '/admin/getTaskStatus';

                // 兜底：先查一次
                axios.post(statusUrl, { task_id: saved.taskId }, {
                    headers: { Authorization: 'Bearer ' + token }
                }).then(function(res) {
                    var status = res.data.status;
                    var download_url = res.data.download_url;
                    var error = res.data.error;

                    if (status === 'completed') {
                        self.$store.dispatch('export/setExport', {
                            progress: 100,
                            status: 'completed',
                            downloadUrl: download_url,
                            isExporting: false,
                            timeText: '导出完成'
                        })
                        return;
                    }
                    if (status === 'failed') {
                        self.$store.dispatch('export/setExport', {
                            status: 'failed',
                            errorMsg: error || '导出失败',
                            isExporting: false
                        })
                        return;
                    }
                    self.ensureConnected();
                    // 还在跑，订阅 WebSocket 
                    self.subscribeProgress(saved.taskId);
                }).catch(function(){
                    self.ensureConnected();
                    // 查询失败也试着订阅
                    self.subscribeProgress(saved.taskId)
                })
            })
        },

        // WebSocket 订阅
        subscribeProgress: function(taskId) {
            var self = this;
            var userId = Cookies.get('view_userId') || 1;

            // 清理旧的
            self.cleanupWs();

            var channel = self.$echo.private('export.' + userId)
                .listen('.progress.updated', function(data) {
                    if (data.task_id !== taskId) return;

                    self.$store.dispatch('export/setExport', {
                        progress: data.percentage || 0
                    })

                    self.updateTimeText(data.processed_count, data.total_count);

                    if (data.status === 'completed') {
                        self.cleanupWs();
                        self.$store.dispatch('export/setExport', {
                            progress: 100,
                            status: 'completed',
                            downloadUrl: data.download_url,
                            isExporting: false,
                            timeText: '导出完成'
                        })
                    } else if (data.status === 'failed') {
                        self.cleanupWs();
                        self.$store.dispatch('export/setExport', {
                            status: 'failed',
                            errorMsg: data.error_message || '导出失败',
                            isExporting: false
                        })
                    }
                })

                self.$store.dispatch('export/setExport', { exportChannel: channel });
                
                // 监听断线重连，重连后补查一次状态
                var pusher = self.$echo.connector.pusher;
                pusher.connection.bind('connected', function() {
                    console.log('WebSocket 重连成功, 补查任务状态');
                    self.checkOnce(taskId);
                })

                // 1小时超时
                setTimeout(function(){
                    if (self.exportTask.exportChannel && self.exportTask.status === 'processing') {
                        self.cleanupWs();
                        self.$store.dispatch('export/setExport', {
                            status: 'failed',
                            errorMsg: '导出超时',
                            isExporting: false
                        })
                    }
                }, 3600000)
        },

        // 补查一次状态(不是轮询，只查一次)
        checkOnce: function(taskId) {
            var self = this;
            if (self.exportTask.status !== 'processing') return;

            var token = Cookies.get('view_userToken');
            var statusUrl = self.exportTask.statusUrl || self.$root.commonPreUrl + '/admin/getTaskStatus';

            axios.post(statusUrl, { task_id: taskId }, {
                headers: { Authorization: 'Bearer ' + token }
            }).then(function(res) {
                var status = res.data.status;
                if(status === 'completed') {
                    self.cleanupWs();
                    self.$store.dispatch('export/setExport', {
                        progress: 100,
                        status: 'completed',
                        downloadUrl: res.data.download_url,
                        isExporting: false,
                        timeText: '导出完成'
                    })
                } else if (status === 'failed') {
                    self.cleanupWs();
                    self.$store.dispatch('export/setExport', {
                        status: 'failed',
                        errorMsg: res.data.error || '导出失败',
                        isExporting: false
                    })
                }
            }).catch(function(){})
        },
        
        updateTimeText: function(processed, total) {
            var elapsed = Date.now() - this.exportTask.startTime;
            var text = '';

            if (processed > 0 && total > 0) {
                var speed = processed / Math.max(elapsed, 1000);
                var left = (total - processed) / Math.max(speed, 0.0001);
                var secs = Math.ceil(left / 1000);
                var mins = Math.floor(secs / 60);
                var s = secs % 60;

                if (mins > 0) {
                    text = '约' + mins + '分' + s + '秒';
                } else if(secs > 0) {
                    text = '约' + secs + '秒';
                } else {
                    text = '即将完成';
                }
            } else {
                var sec = Math.floor(elapsed / 1000);
                var m = Math.floor(sec / 60);
                text = '已' + m + '分' + (sec % 60) + '秒';
            }

            this.$store.dispatch('export/setExport', { timeText: text })
        },

        cleanupWs: function() {
            // 解绑重连监听
            var pusher = this.$echo.connector.pusher;
            pusher.connection.unbind('connected');

            if (this.exportTask.exportChannel) {
                var userId = Cookies.get('view_userId') || 1;
                this.exportTask.exportChannel.stopListening('.progress.updated');
                this.$echo.leave('export.' + userId);
                this.$store.dispatch('export/setExport', { exportChannel: null });
            }
        },
        
        closeExportTip: function() {
            this.cleanupWs();
            this.$store.dispatch('export/resetExport');
        },

        downloadExportFile: function() {
            if (this.exportTask.downloadUrl) {
                window.location.href = this.exportTask.downloadUrl;
                var self = this;
                setTimeout(function() {
                    self.closeExportTip();
                }, 500);
            }
        }
    },
    beforeDestroy: function() {
        // 不清理，让状态保持
    }
}


// WEBPACK FOOTER //
// ./src/mixins/exportMixin.js